export const DATAJSON = [
  {
    type: "subtittle",
    label: "Datos personales",
    fieldName: "",
  },
  {
    type: "text",
    label: "Nombre y Apellido",
    fieldName: "name",
    required: true,
  },
  {
    type: "text",
    label: "DNI",
    fieldName: "DNI",
    required: true,
  },
  {
    type: "text",
    label: "CUIL",
    fieldName: "cuil",
    required: true,
    readOnly: true,
  },
  {
    type: "calendar",
    label: "Fecha de Nacimiento",
    fieldName: "birthDate",
    minDate: 100,
    maxDate: 18,
    required: "true",
  },
  {
    type: "text",
    label: "Sexo",
    fieldName: "sex",
    required: true,
  },
  {
    type: "text",
    label: "Género",
    fieldName: "genre",
    required: true,
  },
  {
    type: "subtittle",
    label: "Datos de contacto",
    fieldName: "",
  },
  {
    type: "text",
    label: "Dirección",
    fieldName: "residence",
    required: true,
  },
  {
    type: "text",
    label: "Localidad",
    fieldName: "location",
    required: true,
  },
  {
    type: "text",
    label: "Provincia",
    fieldName: "province",
    required: true,
  },
  {
    type: "text",
    label: "Código postal",
    fieldName: "postalCode",
    required: true,
  },
  {
    type: "text",
    label: "Teléfono",
    fieldName: "phoneNumber",
    required: true,
  },
  {
    type: "text",
    label: "Email",
    fieldName: "email",
    required: true,
  },
];
